const setFieldState = (selector, show = true, enable = true) => {
  $(selector).toggle(show);
  $(`${selector} select, ${selector} input`).prop("disabled", !enable);
};

const updateOptions = () => {
  if (!$(".variant-input-wrap").length) return;

  const selectedVariant = $(".variant-input-wrap select").val()?.toLowerCase().trim();
  const selectedPantStyle = $(".pant-style select").val()?.toLowerCase().trim();

  setFieldState(".jersey-name", false, false);
  setFieldState(".jersey-number", false, false);
  setFieldState(".jersey-size", false, false);
  setFieldState(".pant-size", false, false);
  setFieldState(".jogger-size", false, false);
  setFieldState(".pant-style", false, false);

  if (selectedVariant === "jersey") {
    setFieldState(".jersey-name");
    setFieldState(".jersey-number");
    setFieldState(".jersey-size");
    return;
  }

  if (selectedVariant === "pants") {
    setFieldState(selectedPantStyle === "gravity joggers" ? ".jogger-size" : ".pant-size");
    setFieldState(".pant-style");
    return;
  }

  setFieldState(".jersey-name");
  setFieldState(".jersey-number");
  setFieldState(".jersey-size");
  setFieldState(selectedPantStyle === "gravity joggers" ? ".jogger-size" : ".pant-size");
  setFieldState(".pant-style");
};

const initSliders = () => {
  try {
    $(".slider-left").slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      arrows: false,
      swipe: false,
      slidesToShow: 4,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false,
      rtl: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            variableWidth: true,
            slidesToShow: 2,
          },
        },
      ],
    });
  } catch (e) {}

  try {
    $(".slider-right").slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      arrows: false,
      swipe: false,
      slidesToShow: 4,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false,
      rtl: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            variableWidth: true,
            slidesToShow: 2,
          },
        },
      ],
    });
  } catch (e) {}
};

$(document).ready(function () {
  updateOptions();
  initSliders();

  $(document).on("change", ".variant-input-wrap select, .pant-style select", function () {
    updateOptions();
  });
});

document.addEventListener("shopify:section:load", function (e) {
  updateOptions();
  initSliders();
});

document.addEventListener("shopify:section:select", function (e) {
  updateOptions();
  initSliders();
});